import React from "react";
import { Markup } from "interweave";
import MakeBoard from "../components/BridgeBoard/MakeBoard";
import database from "../firebase/config";

Array.prototype.unique = function () {
  return this.filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
};

const suitRanks = { A: 14, K: 13, Q: 12, J: 11, T: 10 };

export const sortSuitRanks = (x, y) => {
  let xFaceCard = "AKQJT".includes(x);
  let yFaceCard = "AKQJT".includes(y);
  let xValue = xFaceCard ? suitRanks[x] : Number(x);
  let yValue = yFaceCard ? suitRanks[y] : Number(y);
  if (xValue < yValue) return 1;
  else return -1;
};

const filterOutNoncards = (card) => "23456789TJQKA".includes(card);

export const sortCardString = (cards) => {
  if (cards !== "") {
    cards = cards.replace("1", "T");
    cards = cards
      .toUpperCase()
      .split("")
      .filter(filterOutNoncards)
      .unique()
      .sort(sortSuitRanks)
      .join("");
  }
  return cards;
};
export const noDuplicateCardsOfSameSuit = (North, East, South, West, suit) => {
  let concatenatedString = North[suit] + East[suit] + South[suit] + West[suit];
  return (
    concatenatedString.length == concatenatedString.split("").unique().length
  );
};

export const fetchDataChunk = (from, howMany, orderBy) => {
  return database
    .collection(from)
    .orderBy(orderBy, "desc")
    .limit(howMany)
    .get()
    .then((snapshot) => {
      const data = [];
      snapshot.forEach((childSnapshot) => {
        data.push({
          id: childSnapshot.id,
          from: from,
          ...childSnapshot.data(),
        });
      });
      return data;
    });
};

export const urlToCategory = (url) => {
  switch (url) {
    case "conventions":
      return "Conventions & Systems";
  }
};

export const getMaxBidFromBiddingString = (bidding) => {
  // console.log(bidding);
  let highestBid = "0♣";
  for (let bid of bidding.reverse()) {
    switch (bid) {
      case "_":
      case "X":
      case "XX":
      case "P":
        break;
      default:
        if (isGreaterBid(bid, highestBid)) {
          highestBid = bid;
        }
    }
  }

  // console.log(highestBid);
  return highestBid;
};

// enemy->partner->enemy->me->enemy
export const canDoubleChecker = (bidding) => {
  // return [true, true];

  // const positions = ["West", "North", "East", "South"];
  // const Position = Object.freeze({
  //     West:0, North:1, East:2, South:3,
  // });
  // const PositionRev = Object.freeze({
  //     0:"West", 1:"North", 2:"East", 3:"South",
  // });

  if (!bidding) return [false, false];

  let canDouble = false;
  let canRedouble = false;

  const numBids = bidding.length;
  let player = numBids % 4;

  let lastLevel = 0;
  let lastDoubled = false;
  let lastRedoubled = false;
  let playerWhoBetNormallyLast;
  let currentPlayer = 0;

  for (let bid of bidding) {
    // console.log(bid);
    switch (bid) {
      case "X":
        lastDoubled = true;
        break;
      case "XX":
        lastRedoubled = true;
        lastDoubled = false;
        break;
      case "P":
        break;
      case "_":
        break;
      default:
        playerWhoBetNormallyLast = currentPlayer;
        lastDoubled = false;
        lastRedoubled = false;
        lastLevel = bid[0] > lastLevel ? (lastLevel = bid[0]) : lastLevel;
      // console.log("UPDATED LASTLEVEL to " + lastLevel);
    }

    currentPlayer = (currentPlayer + 1) % 4;
  }

  // canDouble = (!lastLevel && lastDoubled && lastRedoubled && !(player % 2 == playerWhoBetNormallyLast % 2));
  // canRedouble = (!lastLevel && !lastDoubled && lastRedoubled && (player % 2 != playerWhoBetNormallyLast % 2));

  // Negated Disjunction:
  // canDouble = !(!lastLevel || lastDoubled || lastRedoubled || !(player % 2 == playerWhoBetNormallyLast % 2));
  // canRedouble = !(!lastLevel || !lastDoubled || lastRedoubled || (player % 2 != playerWhoBetNormallyLast % 2));

  const myTeam = player % 2;

  // Positive Conjunction:
  canDouble =
    lastLevel &&
    !lastDoubled &&
    !lastRedoubled &&
    !(player % 2 == playerWhoBetNormallyLast % 2);

  canRedouble =
    lastLevel &&
    lastDoubled &&
    !lastRedoubled &&
    player % 2 === playerWhoBetNormallyLast % 2;

  // let shits = [lastLevel, lastDoubled, lastRedoubled, (player % 2 == playerWhoBetNormallyLast % 2)];
  // console.log(shits);

  // let canDoubleArr = [!lastLevel, lastDoubled, lastRedoubled, !(player % 2 == playerWhoBetNormallyLast % 2)];
  // let canRedoubleArr = [!lastLevel, !lastDoubled, lastRedoubled, (player % 2 != playerWhoBetNormallyLast % 2)];
  // console.log([lastLevel, lastDoubled, lastRedoubled, player, playerWhoBetNormallyLast]);
  // console.log(canDoubleArr);
  // console.log(canRedoubleArr);

  return [canDouble, canRedouble];
};

// 1) Cant double your partner
// 2) Cant double a double or a redouble
// 1) Cant redouble your partner
// 2) Can only redouble if last bid was a double and made by your opponents.

const normalizeRedSuitSpanOpenTag = (string) => {
  return string
    .replace(
      /<span\s+className=['"]red-suit['"]\s*>/g,
      `<span class="red-suit">`
    )
    .replace(
      /<span\s+class=['"]red-suit['"]\s*>/g,
      `<span class="red-suit">`
    );
};

export const prepareArticleString = (article) => {
  return normalizeRedSuitSpanOpenTag(
    colourSuitsInHtml(
      article
        .split("&gt;")
        .join(">")
        .split("&lt;")
        .join("<")
        .split(/(![shcdSHCD])/)
        .map((substr) => replaceSuitMacros(substr))
        .join("")
    )
  );
};

// Suit glyphs (and their HTML entities) that must never render uncoloured.
// Diamonds keep the long-standing `red-suit` class for article bodies; clubs are green.
const HTML_SUIT_CLASS = {
  "♥": "red-suit",
  "♦": "red-suit",
  "♣": "club-suit",
  "&hearts;": "red-suit",
  "&diams;": "red-suit",
  "&clubs;": "club-suit",
};
const HTML_SUIT_TOKEN = /&hearts;|&diams;|&clubs;|[♥♦♣]/g;

/**
 * Wrap every ♥ / ♦ / ♣ (and &hearts; &diams; &clubs;) that sits in a TEXT node of
 * an HTML string in its colour span. HTML-aware, so it never touches anything
 * inside a tag (attributes such as MakeBoard's bidding="_/1♦/P/1♥" or alt="2♥"),
 * comments, or <script>/<style>, and it does not double-wrap a glyph that is
 * already inside a suit-class span. Idempotent.
 */
export const colourSuitsInHtml = (html) => {
  if (html == null) return html;
  const str = String(html);
  if (!/[♥♦♣]|&hearts;|&diams;|&clubs;/.test(str)) return str;

  let out = "";
  let i = 0;
  const len = str.length;
  // Stack of open <span>/<font> elements: true when that element already colours a suit.
  const spanStack = [];
  let rawTextUntil = null; // e.g. "</script" while inside script/style

  const wrapText = (text) => {
    if (spanStack.some(Boolean)) return text;
    return text.replace(HTML_SUIT_TOKEN, (g) => `<span class="${HTML_SUIT_CLASS[g]}">${g}</span>`);
  };

  while (i < len) {
    if (rawTextUntil) {
      const close = str.toLowerCase().indexOf(rawTextUntil, i);
      const stop = close === -1 ? len : close;
      out += str.slice(i, stop);
      i = stop;
      rawTextUntil = null;
      continue;
    }
    const lt = str.indexOf("<", i);
    if (lt === -1) {
      out += wrapText(str.slice(i));
      break;
    }
    const next = str[lt + 1];
    const isTag = next !== undefined && /[A-Za-z/!?]/.test(next);
    if (!isTag) {
      out += wrapText(str.slice(i, lt + 1));
      i = lt + 1;
      continue;
    }
    out += wrapText(str.slice(i, lt));
    // Comment
    if (str.startsWith("<!--", lt)) {
      const endC = str.indexOf("-->", lt + 4);
      const stop = endC === -1 ? len : endC + 3;
      out += str.slice(lt, stop);
      i = stop;
      continue;
    }
    // Scan to the end of the tag, respecting quoted attribute values.
    let j = lt + 1;
    let quote = null;
    while (j < len) {
      const ch = str[j];
      if (quote) {
        if (ch === quote) quote = null;
      } else if (ch === '"' || ch === "'") {
        quote = ch;
      } else if (ch === ">") {
        break;
      }
      j += 1;
    }
    const tag = str.slice(lt, Math.min(j + 1, len));
    out += tag;
    i = Math.min(j + 1, len);

    const m = tag.match(/^<\s*(\/)?\s*([A-Za-z][A-Za-z0-9-]*)/);
    if (m) {
      const closing = !!m[1];
      const name = m[2].toLowerCase();
      const selfClosing = /\/\s*>$/.test(tag);
      if (name === "span" || name === "font") {
        if (closing) {
          spanStack.pop();
        } else if (!selfClosing) {
          const cls = (tag.match(/\bclass(?:Name)?\s*=\s*["']([^"']*)["']/i) || [])[1] || "";
          spanStack.push(/suit/i.test(cls));
        }
      } else if (!closing && (name === "script" || name === "style")) {
        rawTextUntil = `</${name}`;
      }
    }
  }
  return out;
};

export const replaceSuitMacros = (substr) => {
  switch (substr) {
    case "!c":
    case "!C":
      return "♣";
    case "!d":
    case "!D":
      return "♦";
    // return `<span className='red-suit'>♦</span>`;
    case "!h":
    case "!H":
      return "♥";
    // return `<span className='red-suit'>♥</span>`;
    case "!s":
    case "!S":
      return "♠";
    default:
      return substr;
  }
};

export const SUITS = ["♣", "♦", "♥", "♠", "NT"];
const orderedSides = ["West", "North", "East", "South"];
export const SUIT_VALUE_MAPPER = {
  "♣": 1,
  "♦": 2,
  "♥": 3,
  "♠": 4,
  NT: 5,
};
export const SUIT_NAME_MAPPER = {
  "♣": "club",
  "♦": "diamond",
  "♥": "heart",
  "♠": "spade",
  NT: "NT",
};

export const isGreaterBid = (currentMaxBid, newBid) => {
  let isGreater = false;
  if (currentMaxBid[0] > newBid[0]) {
    // isGreater = true;
    return true;
  } else if (currentMaxBid[0] === newBid[0]) {
    // isGreater = compareSuits(currentMaxBid.slice(1), newBid.slice(1));
    return compareSuits(currentMaxBid.slice(1), newBid.slice(1));
  }
  // console.log(currentMaxBid, newBid, isGreater);
  // return isGreater;
  return false;
};

export const compareSuits = (leftSuit, rightSuit) => {
  return SUIT_VALUE_MAPPER[leftSuit] >= SUIT_VALUE_MAPPER[rightSuit];
};

export const getWhoBidWhatSuitFirst = (bids) => {
  const whoBidFirst = {
    "♣": false,
    "♦": false,
    "♥": false,
    "♠": false,
    NT: false,
  };

  const bidding = bids.split("/");
  for (let i = 0; i < bidding.length; i++) {
    let bid;
    switch (bidding[i]) {
      case "P":
      case "XX":
      case "X":
      case "_":
        continue;
        break;
      default:
        bid = getSuitFromBid(bidding[i]);
    }
    if (bid && !whoBidFirst[bid]) {
      whoBidFirst[bid] = orderedSides[i % 4];
    }
  }
  return whoBidFirst;
};

export const getLastBid = (bids) => {
  let bidding = bids.split("/");
  let lastBid;
  let idx = bidding.length - 1;
  // let idx = bidding.length-1;
  for (; idx >= 0; idx--) {
    switch (bidding[idx]) {
      case "P":
      case "XX":
      case "X":
      case "_":
        continue;
        break;
      default:
        lastBid = getSuitFromBid(bidding[idx]);
        break;
    }
    if (lastBid) {
      break;
    }
  }
  return [lastBid, orderedSides[idx % 4]];
  // orderedSides;
};

export const getSuitFromBid = (bid) => {
  return bid.slice(1);
};

export const sortCategoryArticlesByLevelAndArticleNumber = (articles) => {
  // Sort numbers in ascending order:
  //.sort((a, b) => return a - b)
  if (!Array.isArray(articles) || articles.length === 0) return [];
  const compareFnByArticleNumber = (a, b) =>
    Number(a?.articleNumber) - Number(b?.articleNumber);

  const intermediateValue = articles.reduce((acc, next, idx) => {
    const difficulty = next?.difficulty;
    if (acc?.[difficulty] === undefined) {
      acc[difficulty] = [next];
      return acc;
    } else {
      acc[difficulty].push(next);
      return acc;
    }
  }, {});

  const finalResults = [];

  for (const [key, value] of Object.entries(intermediateValue)) {
    const newArr = [...value];
    newArr.sort(compareFnByArticleNumber);
    finalResults.push(newArr);
  }

  const flattenedResults = finalResults.flat();

  // console.log("--- FROM HELPERS sortCategory ---");
  // console.log(articles);
  // console.log(intermediateValue);
  // console.log(finalResults);
  // console.log(flattenedResults);

  return flattenedResults;
};

export const filterCategoryArticles = (
  articlesArray,
  { category, difficulty, searchString }
) => {
  if (
    // category == '""' &&
    difficulty == '""' &&
    (searchString == "" || searchString == '""')
  ) {
    return articlesArray;
  }

  return articlesArray.filter((article) => {
    let categoriesMatch = true;
    let difficultiesMatch = true;
    let searchStringMatch = true;

    let toSearch;
    if (searchString && searchString !== '""') {
      toSearch = [
        article.category,
        getDifficultyStr(article.difficulty),
        article.title,
        article.teaser,
      ]
        .join(" ")
        .toLowerCase();
      searchStringMatch = toSearch.includes(searchString.toLowerCase());
    }

    if (category && category !== '""') {
      categoriesMatch = article.category === category;
    }
    if (difficulty && difficulty !== '""') {
      difficultiesMatch = article.difficulty === difficulty;
    }
    // return categoriesMatch && difficultiesMatch && searchStringMatch;
    return difficultiesMatch && searchStringMatch;
  });
};

export const filterArticles = (
  articlesArray,
  { category, difficulty, searchString }
) => {
  // console.log(articlesArray);
  // console.log(category, difficulty, searchString);
  // console.log(searchString == "");
  if (
    category == '""' &&
    difficulty == '""' &&
    (searchString == "" || searchString == '""')
  ) {
    // console.log("IN HERE");
    // console.log(articlesArray);
    return articlesArray;
  }

  return articlesArray.filter((article) => {
    let categoriesMatch = true;
    let difficultiesMatch = true;
    let searchStringMatch = true;

    let toSearch;
    if (searchString && searchString !== '""') {
      toSearch = [
        article.category,
        getDifficultyStr(article.difficulty),
        article.title,
        article.teaser,
      ]
        .join(" ")
        .toLowerCase();
      searchStringMatch = toSearch.includes(searchString.toLowerCase());
    }

    if (category && category !== '""') {
      categoriesMatch = article.category === category;
    }
    if (difficulty && difficulty !== '""') {
      difficultiesMatch = article.difficulty === difficulty;
    }
    return categoriesMatch && difficultiesMatch && searchStringMatch;
  });
};

const filterByQuizScores = (articles, quizScores) => {
  if (quizScores !== undefined) {
    return articles.filter((article) => {
      return quizScores[article.body] === undefined;
    });
  } else {
    return articles;
  }
};

export const filterQuizzes = (
  articlesArray,
  { category, difficulty, searchString, hide, quizScores = {} },
  quizScoresDB
) => {
  // console.log(quizScores);
  // console.log(hide);
  // console.log(articlesArray);
  // console.log(category, difficulty, searchString);
  // console.log(searchString == "");
  if (
    category == '""' &&
    difficulty == '""' &&
    (searchString == "" || searchString == '""')
  ) {
    // console.log("IN HERE");
    // console.log(articlesArray);
    if (hide) return filterByQuizScores(articlesArray, quizScoresDB);
    else return articlesArray;
  }

  return articlesArray.filter((article) => {
    let categoriesMatch = true;
    let difficultiesMatch = true;
    let searchStringMatch = true;
    let showCompleted = true;
    let showCompletedDB = true;

    let toSearch;
    if (searchString !== '""') {
      toSearch = [
        article.quizType,
        getDifficultyStr(article.difficulty),
        article.title,
        article.teaser,
      ]
        .join(" ")
        .toLowerCase();
      searchStringMatch = toSearch.includes(searchString.toLowerCase());
    }

    if (category !== '""') {
      categoriesMatch = article.quizType === category;
    }
    if (difficulty !== '""') {
      difficultiesMatch = article.difficulty === difficulty;
    }

    if (hide && quizScores !== undefined) {
      showCompleted = quizScores[article.body] === undefined;
      showCompletedDB = quizScoresDB[article.body] === undefined;
      // if (article.title === "Add to favourites") {
      //     console.log(quizScores[article.body]);
      //     console.log(quizScoresDB[article.body]);
      //     console.log("SHOULD BE HIDDEN");
      //     console.log(showCompleted);
      // }
    }

    return (
      showCompletedDB &&
      showCompleted &&
      categoriesMatch &&
      difficultiesMatch &&
      searchStringMatch
    );
  });
};

export const makeDateString = (date) => {
  if (!date) {
    return "N/A";
  }
  
  try {
    // Handle Firestore Timestamp
    let dateData;
    if (date && typeof date.toDate === 'function') {
      dateData = date.toDate();
    } else if (date instanceof Date) {
      dateData = date;
    } else {
      dateData = new Date(date);
    }
    
    // Validate the date
    if (isNaN(dateData.getTime())) {
      return "Invalid date";
    }
    
    let dateString = dateData.toString().split(" ");
    return `${dateString[0].slice(0, 3)} ${dateString[1]} ${dateString[2]}, ${
      dateString[3]
    }`;
  } catch (e) {
    // Error converting date - return safe fallback
    return "Date unavailable";
  }
  // let dateData;
  // if (date)
  //     dateData = date.toString().split(" ");
  // else {
  //     dateData = (new Date().toString().split(" "));
  // }
  // return `${dateData[0].slice(0, 3)} ${dateData[1]} ${dateData[2]}`;
};

export const makeBoardObjectFromString = (boardString, showVuln = false) => {
  if (boardString === "") return undefined;
  try {
    const data = {};
    
    // Use regex to extract all key="value" pairs, handling values with spaces
    // This regex matches: key="value" where value can contain spaces
    const attrRegex = /(\w+)="([^"]*)"/g;
    let match;
    
    while ((match = attrRegex.exec(boardString)) !== null) {
      const [, key, value] = match;
      data[key] = value;
    }
    
    console.log('=== makeBoardObjectFromString DEBUG ===');
    console.log('Input:', boardString);
    console.log('Parsed data:', data);
    
    // Map directly - keys in MakeBoard tags are already capitalized (North, South, etc.)
    const result = {
      boardType: data.boardType || '',
      position: data.position || '',
      North: data.North || '',
      South: data.South || '',
      East: data.East || '',
      West: data.West || '',
      vuln: data.vuln || data.Vuln || 'none',
      dealer: data.dealer || data.Dealer || 'North',
      bidding: data.bidding || data.Bidding || '',
      showVuln: showVuln,
    };
    
    console.log('Result object:', result);
    console.log('North value:', result.North);
    console.log('North split by *:', result.North.split('*'));
    
    return result;
  } catch (e) {
    console.error('Error parsing MakeBoard tag:', e, boardString);
    return {};
  }
};

export const findArticleById = (data, id) => {
  // IMPORTANT: return `undefined` when we don't have data yet, so callers can trigger metadata fetches.
  // `id` may be a readable slug (new canonical URL) or a body doc id (legacy URL).
  if (!Array.isArray(data)) return undefined;
  return data.find((el) => el.slug === id || el.body === id);
};

export const findQuizById = (data, id) => {
  const res = data?.find((el) => el.id === id);
  return res;
  // return data.find(el => el.body === id);
};

export const getLevelStr = (levelNumber) => {
  let levelStr = "";
  return `Level ${levelNumber}`;
};

export const getDifficultyStr = (difficulty) => {
  let diffString;
  switch (difficulty) {
    case "":
      diffString = "";
      break;
    case "general":
      diffString = "General";
      break;
    case "adv":
      diffString = "Advanced";
      break;
    case "int":
      diffString = "Intermediate";
      break;
    case "beg":
      diffString = "Improver";
      break;
  }

  return diffString;
};

export const getQuizData = (documentString) => {
  // console.log("--- Making board from document string ---");
  // console.log(documentString);
  // console.log(documentString.split(/(<MakeBoard .* \/>)/));
  const re = /(<MakeBoard .* \/>)/;
  const matches = re.exec(documentString);
  if (matches) {
    const boardString = matches[0];
    return makeBoardObjectFromString(boardString);
  }
};

// Helper function to extract YouTube video ID from URL
const extractYouTubeVideoId = (url) => {
  if (!url) return null;
  
  try {
    const urlObj = new URL(url);
    if (urlObj.hostname.includes('youtube.com')) {
      return urlObj.searchParams.get('v');
    } else if (urlObj.hostname.includes('youtu.be')) {
      return urlObj.pathname.slice(1);
    }
  } catch (e) {
    // Try regex fallback for URLs that might not parse correctly
    const youtubeRegex = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(youtubeRegex);
    if (match) return match[1];
  }
  
  return null;
};

// Helper function to render video embed with premium gating.
// `canWatchVideoOverride` allows callers (e.g. free articles) to bypass the premium check.
const renderVideoEmbed = (
  videoUrl,
  key,
  tier,
  history,
  canWatchVideoOverride = undefined
) => {
  const videoId = extractYouTubeVideoId(videoUrl);
  if (!videoId) return null;
  
  const isPremium = tier === 'premium';
  const canWatch =
    canWatchVideoOverride !== undefined ? !!canWatchVideoOverride : isPremium;
  
  if (canWatch) {
    return (
      <div key={key} className="Article-video-container" role="region" aria-label="Video content">
        <iframe
          className="Article-video-player"
          src={`https://www.youtube.com/embed/${videoId}`}
          title="Article video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          aria-label="YouTube video player"
          onError={(e) => {
            // Note: iframe onError doesn't fire due to cross-origin restrictions
            // But we can add a fallback message container
            logger.error('Video iframe failed to load:', videoId);
          }}
        />
        <div className="Article-video-error" style={{ display: 'none', padding: '1rem', backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '4px', marginTop: '0.5rem' }}>
          <p style={{ margin: 0, color: '#856404' }}>
            <strong>⚠️ Video unavailable:</strong> This video may be set to Private. 
            Please change the video privacy setting to "Unlisted" in YouTube Studio for it to be viewable here.
          </p>
        </div>
      </div>
    );
  } else {
    // Non-premium users see paywall
    return (
      <div key={key} className="Article-video-container">
        <div className="Article-video-paywall">
          <div className="Article-video-blur">
            <div className="Article-video-lock-icon">🔒</div>
          </div>
          <div className="Article-video-paywall-content">
            <h3>Premium Content</h3>
            <p>Upgrade to Premium to watch this video</p>
            <button
              className="Article-video-upgrade-btn"
              onClick={() => {
                if (typeof sessionStorage !== "undefined") sessionStorage.setItem("subscription_upgrade_source", "video");
                if (history && history.push) history.push("/membership");
              }}
              aria-label="Upgrade to premium membership to watch this video"
            >
              Upgrade to Premium
            </button>
          </div>
        </div>
      </div>
    );
  }
};

// Helper function to detect if article has videos
export const hasVideosInContent = (documentString) => {
  if (!documentString || typeof documentString !== 'string') return false;
  
  // Check for Video component tags
  const videoTagRegex = /<Video\s+url=["']([^"']+)["']\s*\/>|<Video>([^<]+)<\/Video>/gi;
  if (videoTagRegex.test(documentString)) return true;
  
  // Check for YouTube URLs in various formats
  const youtubeUrlPatterns = [
    /youtube\.com\/watch\?v=[a-zA-Z0-9_-]{11}/gi,
    /youtu\.be\/[a-zA-Z0-9_-]{11}/gi,
    /youtube\.com\/embed\/[a-zA-Z0-9_-]{11}/gi,
    /youtube\.com\/v\/[a-zA-Z0-9_-]{11}/gi,
  ];
  if (youtubeUrlPatterns.some(pattern => pattern.test(documentString))) return true;
  
  // Check for YouTube iframe embeds
  const iframeRegex = /<iframe[^>]*src=["'][^"']*youtube[^"']*["'][^>]*>/gi;
  if (iframeRegex.test(documentString)) return true;
  
  // Check for any video-related URLs (broader catch)
  const videoUrlRegex = /(https?:\/\/[^\s<>"']*(?:youtube|vimeo|dailymotion)[^\s<>"']*)/gi;
  if (videoUrlRegex.test(documentString)) return true;
  
  return false;
};

export const parseDocumentIntoJSX = (
  documentString,
  quiz = false,
  callback = undefined,
  quizType = undefined,
  tier = undefined,
  history = undefined,
  canWatchVideoOverride = undefined
) => {
  // Ensure documentString is a string
  if (!documentString) return [];
  if (typeof documentString !== 'string') {
    console.error('parseDocumentIntoJSX: documentString is not a string:', typeof documentString, documentString);
    documentString = String(documentString || '');
  }

  // Hearts/diamonds in stored HTML (including script-written bodies) must render red.
  documentString = prepareArticleString(documentString);

  // First, split by video tags/patterns, then by MakeBoard tags
  // Support both <Video url="..." /> and <Video>...</Video> formats
  // Also support YouTube URLs directly in text
  let parts = [];
  let currentIndex = 0;
  let partIndex = 0;
  
  // Regex to match video tags and YouTube URLs
  const videoTagRegex = /<Video\s+url=["']([^"']+)["']\s*\/>|<Video>([^<]+)<\/Video>/gi;
  // Updated regex to match YouTube URLs even when wrapped in HTML tags or with query parameters
  // This will match URLs like: https://www.youtube.com/watch?v=VIDEO_ID or https://youtu.be/VIDEO_ID
  // Even if they're inside <p> tags or have additional query parameters
  const youtubeUrlRegex = /(https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)[a-zA-Z0-9_-]{11}(?:[^\s<>"']*)?)/gi;
  
  // Find all video matches
  const videoMatches = [];
  let match;
  
  // Match video tags
  while ((match = videoTagRegex.exec(documentString)) !== null) {
    videoMatches.push({
      index: match.index,
      length: match[0].length,
      url: match[1] || match[2],
      type: 'tag'
    });
  }
  
  // Match YouTube URLs (but not if they're already in video tags)
  while ((match = youtubeUrlRegex.exec(documentString)) !== null) {
    // Check if this URL is already captured in a video tag
    const isInTag = videoMatches.some(vm => 
      match.index >= vm.index && match.index < vm.index + vm.length
    );
    
    if (!isInTag) {
      videoMatches.push({
        index: match.index,
        length: match[0].length,
        url: match[0],
        type: 'url'
      });
    }
  }
  
  // Sort matches by index
  videoMatches.sort((a, b) => a.index - b.index);
  
  // Split document by video matches and MakeBoard tags
  let processedString = documentString;
  let offset = 0;
  
  // Replace video matches with placeholders
  const videoPlaceholders = [];
  videoMatches.forEach((vm, idx) => {
    const placeholder = `__VIDEO_PLACEHOLDER_${idx}__`;
    videoPlaceholders.push({
      placeholder,
      url: vm.url
    });
    processedString = processedString.substring(0, vm.index + offset) + 
                     placeholder + 
                     processedString.substring(vm.index + vm.length + offset);
    offset += placeholder.length - vm.length;
  });
  
  // Ensure processedString is a string before calling .replace()
  if (typeof processedString !== 'string') {
    console.error('parseDocumentIntoJSX: processedString is not a string:', typeof processedString, processedString);
    processedString = String(processedString || '');
  }
  
  // Now split by MakeBoard tags - handle various formats including HTML-escaped and wrapped in tags
  // First, unescape any HTML entities that might have been escaped
  processedString = processedString
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&');
  
  // Extract MakeBoard tags that might be wrapped in HTML tags (e.g., <p><MakeBoard ... /></p>)
  // Replace wrapped MakeBoard tags with just the MakeBoard tag
  processedString = processedString.replace(/<[^>]*>(<MakeBoard[^>]*\/>)<\/[^>]*>/g, '$1');
  
  // Split by MakeBoard tags - more flexible regex to handle different spacing and formats
  const segments = processedString.split(/(<MakeBoard[^>]*\/>)/);
  
  // Process each segment
  const articleDataArray = [];
  let globalIdx = 0;
  const calloutRegex = /<Callout\s+type=["'](rule|example|mistake|checklist|expert)["']\s*>([\s\S]*?)<\/Callout>/gi;
  const renderSegmentWithCallouts = (segment, keyBase) => {
    const items = [];
    if (!segment || !segment.trim()) return items;

    let cursor = 0;
    let localIdx = 0;
    let match;
    calloutRegex.lastIndex = 0;

    while ((match = calloutRegex.exec(segment)) !== null) {
      const before = segment.slice(cursor, match.index);
      if (before.trim()) {
        items.push(
          <Markup key={`${keyBase}-content-${localIdx}`} content={before} />
        );
      }

      const type = (match[1] || "rule").toLowerCase();
      const body = (match[2] || "")
        .trim()
        .replace(/<ul>/gi, '<ul class="browser-default">')
        .replace(/<ol>/gi, '<ol class="browser-default">');
      const badgeMap = {
        rule: "Rule",
        example: "Example",
        mistake: "Common mistake",
        checklist: "Checklist",
        expert: "Expert rule",
      };

      items.push(
        <aside
          key={`${keyBase}-callout-${localIdx}`}
          className={`ArticleCallout ArticleCallout--${type}`}
          role="note"
          aria-label={`${badgeMap[type] || "Callout"} section`}
        >
          <div className="ArticleCallout-badge">{badgeMap[type] || "Callout"}</div>
          <div className="ArticleCallout-body">
            <Markup content={body} />
          </div>
        </aside>
      );

      cursor = match.index + match[0].length;
      localIdx += 1;
    }

    const after = segment.slice(cursor);
    if (after.trim()) {
      items.push(<Markup key={`${keyBase}-content-tail`} content={after} />);
    }

    return items;
  };
  
  segments.forEach((segment, segIdx) => {
    if (segment.includes("MakeBoard")) {
      // Extract just the MakeBoard tag if it's mixed with other content
      const makeBoardMatch = segment.match(/(<MakeBoard[^>]*\/>)/);
      const makeBoardTag = makeBoardMatch ? makeBoardMatch[1] : segment;
      
      // Render MakeBoard
      articleDataArray.push(
        <div key={`board-${globalIdx}`} className="Display-board_container">
          <br />
          <MakeBoard
            {...makeBoardObjectFromString(makeBoardTag, true)}
            getBidding={callback}
            isQuiz={quiz}
            quizType={quizType}
          />
          <br />
        </div>
      );
      globalIdx++;
    } else if (segment.includes("__VIDEO_PLACEHOLDER_")) {
      // Extract placeholder index and render video
      const placeholderMatch = segment.match(/__VIDEO_PLACEHOLDER_(\d+)__/);
      if (placeholderMatch) {
        const placeholderIdx = parseInt(placeholderMatch[1]);
        const videoData = videoPlaceholders[placeholderIdx];
        if (videoData) {
          const videoEmbed = renderVideoEmbed(
            videoData.url,
            `video-${globalIdx}`,
            tier,
            history,
            canWatchVideoOverride
          );
          if (videoEmbed) {
            articleDataArray.push(videoEmbed);
            globalIdx++;
          }
        }
        // Remove placeholder from segment before rendering as Markup
        segment = segment.replace(/__VIDEO_PLACEHOLDER_\d+__/g, '');
      }
      
      // Render remaining content as Markup if there's any
      if (segment.trim()) {
        const rendered = renderSegmentWithCallouts(segment, `content-${globalIdx}`);
        rendered.forEach((node) => articleDataArray.push(node));
        globalIdx += rendered.length;
      }
    } else if (segment.trim()) {
      // Regular content
      const rendered = renderSegmentWithCallouts(segment, `content-${globalIdx}`);
      rendered.forEach((node) => articleDataArray.push(node));
      globalIdx += rendered.length;
    }
  });
  
  return articleDataArray;
};

// const bindings = {};
// const re = /<MakeBoard .*\/>/;
// let matches;
// let articleDataArray = [];
// let curIdx = 0;
// let id = 0;
// let strRemaining;
// if (documentString) {
//     strRemaining = documentString.slice(curIdx);
//     do {
//         strRemaining = strRemaining.slice(curIdx);
//         console.log(strRemaining);
//         matches = re.exec(strRemaining);
//         console.log(matches);
//         if (matches) {
//             let boardStrLen = matches[0].length;
//             console.log(boardStrLen);
//             let strBefore = matches.input.slice(0, matches.index);
//             let boardStr = matches[0];
//             curIdx = matches.index + boardStrLen;
//             articleDataArray.push(<Markup key={id} content={strBefore}/>);
//             id += 1
//             articleDataArray.push(
//                 <div key={id} className="Display-board_container">
//                     <br/>
//                     <br/>
//                     <MakeBoard {...makeBoardObjectFromString(boardStr, true)}
//                                getBidding={callback}
//                                isQuiz={quiz}
//                                quizType={quizType}
//                     />
//                 </div>
//             );
//             id += 1
//         }
//     } while (matches);
//     // articleDataArray.push(<Markup key={id+1} content={strRemaining.slice(curIdx)} />);
//     articleDataArray.push(<Markup key={id+1} content={strRemaining} />);
//     return articleDataArray;
//     }
// };
